import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface EditIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function ExpandLessIcon({ color = RoutalPalette.secondary60, style = {}, ...props }: EditIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" style={{ height: `24px`, width: `24px`, fill: `transparent`, ...style }}>
      <g>
        <path d="M5 15.5L12 8.5L19 15.5" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </SvgIcon>
  );
}
